import styled from '@xstyled/styled-components';
import React, { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { select } from '~/lib/select';
import { SettingsButtonEds } from '~/ui/buttons/SettingsButtonEds';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';
import { MediaPlayerStore } from '~/ui/video-player/MediaPlayerStore';
import { SettingsPages, useSettingsStore } from './Store';

const Button = styled(SettingsButtonEds)`
  position: fixed;
  top: 20px;
  right: 8px;
  font-size: 30px;
  z-index: hud;
  padding: 0px;
  @media ((max-width: 580px) and (max-height: 300px)) {
    right: 10px;
  }
  @media (max-height: 220px) {
    top: 8px;
    right: 10px;
  }
`;

const selector = (s: MediaPlayerStore) => select(s, 'pause');

export const OpenSettingsButton = forwardRef<HTMLButtonElement>(
  function OpenSettingsButton(_props, ref) {
    const { toggle, setPage } = useSettingsStore();
    const { pause } = useMediaPlayerStore(selector);

    return createPortal(
      <Button
        ref={ref}
        onClick={() => {
          setPage(SettingsPages.Root);
          try {
            pause();
          } catch (error) {
            // Silently ignore media player errors
          }
          toggle();
        }}
      />,
      document.getElementById('root')!
    );
  }
);
